export default "__VITE_ASSET__BQerTCmh__"